<template>
  <div>
    <p>{{ label }} payment {{ dateInfo }} (<a :href="link">Payment</a>)</p>
    <ul class="list-unstyled object-details">
      <li>Type: {{ details.payment_type }}</li>
      <li>Amount: {{ details.amount }}</li>
      <li>Status: <span :class="statusClass">{{ details.status }}</span></li>
      <li>Message: <span :class="statusClass">{{ details.message }}</span></li>
      <li>Created: {{ formatDate(details.created_at) }}</li>
      <li  v-if="details.processed_at">Processed: {{ formatDate(details.processed_at) }}</li>
    </ul>
  </div>
</template>

<script>
  import dayjs from 'dayjs';

  export default {
    name: "Payment",
    props: {
      details: {
        type: Object,
        default: function () {
          return {};
        }
      },
      label: {
        type: String,
        default: "Related to"
      }
    },
    computed: {
      link() {
        return `${this.$config.baseUrl}/admin/study/${this.$config.studyId}/payment/${this.details.id}`
      },
      dateInfo() {
        if (this.details.processed_at) {
          return `processed on ${this.formatDate(this.details.processed_at)}`;
        } else {
          return `created on ${this.formatDate(this.details.created_at)}`;
        }
      },
      statusClass() {
        switch (this.details.status) {
          case 'Error':
            return 'text-danger';
          case 'Pending':
            return 'text-warning';
          case 'Success':
          case 'Paid':
            return 'text-success';
        }
      }
    },
    methods: {
      formatDate(date) {
        return dayjs(date).format('MM/DD/YY hh:mm A');
      },
    }
  }
</script>

<style scoped>

</style>